/* Nolvaya PureRinse — variant selection, quantity, add-to-cart.
   Integrates with the Horizon theme cart drawer:
   - refreshes cart-items-component contents
   - dispatches shopify:cart:lines-update so the cart icon + drawer update
   - opens the cart drawer
   Falls back to a native submit if fetch is unavailable. No dependencies. */
(function () {
  'use strict';
  if (window.__nprInit) return; window.__nprInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.nprMoneyFormat) return Shopify.formatMoney(cents, window.nprMoneyFormat);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant(form) {
    var selected = [];
    form.querySelectorAll('[data-npr-opt]').forEach(function (input) {
      if (input.checked) selected[parseInt(input.dataset.nprOpt, 10)] = input.value;
    });
    var sel = form.querySelector('[data-npr-variant-select]');
    if (!sel) return null;
    var match = null;
    Array.prototype.forEach.call(sel.options, function (opt) {
      var opts = (opt.dataset.options || '').split('~~');
      var hit = selected.length ? selected.every(function (v, i) { return v == null || v === opts[i]; }) : false;
      if (hit && !match) match = opt;
    });
    return match;
  }

  function syncVariant(form) {
    var sel = form.querySelector('[data-npr-variant-select]');
    if (!sel) return;
    var match = form.querySelector('[data-npr-opt]') ? findVariant(form) : sel.options[sel.selectedIndex];
    if (!match) return;
    sel.value = match.value;
    var scope = form.closest('[data-npr-scope]');
    var priceEl = scope && scope.querySelector('[data-npr-price]');
    var compareEl = scope && scope.querySelector('[data-npr-compare]');
    var price = parseInt(match.dataset.price, 10);
    var compare = parseInt(match.dataset.compare, 10);
    if (priceEl && !isNaN(price)) priceEl.textContent = money(price);
    if (compareEl) {
      if (compare && compare > price) { compareEl.textContent = money(compare); compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    var available = match.dataset.available === 'true';
    form.querySelectorAll('[data-npr-atc]').forEach(function (atc) { atc.disabled = !available; });
    var txt = form.querySelector('[data-npr-atc-text]');
    if (txt) txt.textContent = available ? (txt.dataset.label || 'Add to cart') : 'Sold out';
  }

  function quantity(form) {
    var input = form.querySelector('[data-npr-qty-input]');
    if (!input) return;
    var minus = form.querySelector('[data-npr-qty-minus]');
    var plus = form.querySelector('[data-npr-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    input.addEventListener('change', function () { var v = parseInt(input.value, 10); if (isNaN(v) || v < 1) v = 1; input.value = v; });
  }

  // Open + refresh the Horizon cart drawer after an add.
  function openHorizonCart() {
    var cartItems = document.querySelector('cart-items-component');
    var refresh = (cartItems && typeof cartItems.fetchCartData === 'function')
      ? Promise.resolve(cartItems.fetchCartData()).catch(function () {})
      : Promise.resolve();

    return refresh.then(function () {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }).then(function (cart) {
      var count = cart ? cart.item_count : null;
      // Notify Horizon (updates the cart-icon bubble; auto-opens drawer if enabled).
      try {
        var ev = new Event('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add'; ev.context = 'product';
        ev.promise = Promise.resolve({ cart: { totalQuantity: count }, detail: { itemCount: count, didError: false } });
        document.dispatchEvent(ev);
      } catch (e) {}
      // Explicitly open the drawer (covers the case where auto-open is disabled).
      var drawer = document.querySelector('cart-drawer-component');
      var themeDrawer = drawer && drawer.closest('theme-drawer');
      if (themeDrawer && typeof themeDrawer.open === 'function') { try { themeDrawer.open(); } catch (e) {} }
    });
  }

  function ajaxAdd(form, opts) {
    opts = opts || {};
    var btn = opts.button || form.querySelector('[data-npr-atc]');
    var err = form.querySelector('[data-npr-error]');
    var fd = new FormData(form);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = (res.d && (res.d.description || res.d.message)) || 'Could not add to cart.'; err.classList.remove('npr-visually-hidden'); }
          return;
        }
        if (err) err.classList.add('npr-visually-hidden');
        if (opts.checkout) { window.location.href = root + 'checkout'; return; }
        var t = form.querySelector('[data-npr-atc-text]');
        if (t) { var old = t.textContent; t.textContent = 'Added ✓'; setTimeout(function () { t.textContent = old; }, 1600); }
        return openHorizonCart();
      })
      .catch(function () { if (!opts.checkout) form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-npr-form]').forEach(function (form) {
      if (form.__nprBound) return; form.__nprBound = true;
      quantity(form);
      form.querySelectorAll('[data-npr-opt]').forEach(function (i) { i.addEventListener('change', function () { syncVariant(form); }); });
      var sel = form.querySelector('[data-npr-variant-select]');
      if (sel && !form.querySelector('[data-npr-opt]')) sel.addEventListener('change', function () { syncVariant(form); });
      form.addEventListener('submit', function (e) { if (window.fetch) { e.preventDefault(); ajaxAdd(form); } });
      form.querySelectorAll('[data-npr-checkout]').forEach(function (cb) {
        cb.addEventListener('click', function (e) { if (window.fetch) { e.preventDefault(); ajaxAdd(form, { checkout: true, button: cb }); } });
      });
      syncVariant(form);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
